"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Styles = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var Styles = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: Arial, sans-serif;\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  border-bottom: ", ";\n"], ["\n  font-family: Arial, sans-serif;\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  border-bottom: ", ";\n"])), function (props) { return props.underline && '1px dotted black'; });
exports.Styles = Styles;
var templateObject_1;
